import { HomeState } from "@/store/types/home.state";
import { Module } from "vuex";
import { RootState } from "@/store/types/root.state";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: HomeState = {
    sections: ['Audiovisual Production', 'Software Development', 'Art', 'Web Development', 'Graphic Design', 'Music'],
    loading: false,
    entries: [],
    typeDisplaying: 'Art',
    artEntries: [],
    webEntries: [],
    audiovisualEntries: [],
    softwareEntries: [],
    graphicDesignEntries: [],
    musicEntries: [],
};

const namespaced = true;

export const HomeModule: Module<HomeState, RootState> = {
    namespaced,
    actions,
    getters,
    mutations,
    state,
}